import {
  Engine,
  LanguageCode,
  OutputFormat,
  PollyClient,
  SynthesizeSpeechCommand,
  TextType,
  VoiceId,
} from "@aws-sdk/client-polly";

const CREDENTIAL = {
  accessKeyId: "AKIAZ5TC45HWZ2MSHZ6N",
  secretAccessKey: "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",
};

const CONFIG = {
  region: "eu-central-1",
  credentials: CREDENTIAL,
};

const INPUT = {
  // StartSpeechSynthesisTaskInput
  Engine: Engine.NEURAL,
  LanguageCode: LanguageCode.pl_PL,
  LexiconNames: [],
  OutputFormat: OutputFormat.MP3, // required
  OutputS3BucketName: "plappbucket", // required
  // OutputS3KeyPrefix: "STRING_VALUE",
  // SampleRate: "5",
  // SnsTopicArn: "STRING_VALUE",
  SpeechMarkTypes: [],
  Text: "STRING_VALUE", // required
  TextType: TextType.TEXT, // TODO: ssml versuchen. // spechmarks only for JSON
  VoiceId: VoiceId.Ola,
  // "Ewa" || "Jacek" || "Jan" || "Maja" || "Ola" // required
};

export function getPollyClient() {
  return new PollyClient(CONFIG);
}

export async function getPollyBitArray(
  client: PollyClient,
  text: string,
): Promise<Uint8Array | null> {
  const input = {
    ...INPUT,
    ...{ Text: text },
  };

  try {
    const synthesizeSpeechCommand = new SynthesizeSpeechCommand(input);
    const response = await client.send(synthesizeSpeechCommand);
    const bitArray = await response.AudioStream?.transformToByteArray();
    return bitArray || null;
  } catch (e) {
    console.log(e);
    return null;
  }
}
